<template>
  <div>
    <div v-if="$store.state.results.site.allow_results">
      <h5 class="text-center">
        {{ translatedFields['please_tell_us_about_yourself'] }}
      </h5>
      <!-- first name / last name-->
      <div class="row">
        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label class="control-label required">
              {{ translatedFields['first_name'] }}
            </label>
            <input class="form-control"
                  type="text"
                  data-vv-as="First Name"
                  name="firstName"
                  v-validate="modelValidations.firstName"
                  v-model="model.firstName"
                  placeholder="ex: Mike"
            />
            <small class="text-danger" v-show="firstName.invalid">
              {{ getError('firstName', 'First') }}
            </small>
          </div>
        </div>
        <div class="col-md-5">
          <div class="form-group">
            <label class="control-label required">
              {{ translatedFields['last_name'] }}
            </label>
            <input class="form-control"
                  type="text"
                  data-vv-as="Last Name"
                  name="lastName"
                  v-validate="modelValidations.lastName"
                  v-model="model.lastName"
                  placeholder="ex: Andrew"
            />
            <small class="text-danger" v-show="lastName.invalid">
              {{ getError('lastName') }}
            </small>
          </div>
        </div>
      </div>
      <!-- dob code-->
      <div class="row">
        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label class="control-label required">
              {{ translatedFields['date_of_birth'] }}
            </label>
            <input class="form-control date-cleave-format"
                  type="text"
                  data-vv-as="Date Of Birth"
                  name="dob_pretty"
                  v-model="model.dob_pretty"
                  placeholder="ex: 12/22/1980"
                  v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                  @change="validateDate($event.target.value)"
                  maxlength="10"
            />
            <small class="text-danger" v-if="errorDate" v-text="errorDate">
              {{ errorDate }}
            </small>
          </div>
        </div>
        <div class="col-md-5">
          <div class="form-group">
            <label class="control-label required">
              {{ translatedFields['confirmation_number'] }}
            </label>
            <input class="form-control"
                  type="text"
                  data-vv-as="Confirmation Number"
                  name="code"
                  v-validate="modelValidations.code"
                  v-model="model.code"
            />
            <small class="text-danger" v-show="code.invalid">
              {{ getError('code') }}
            </small>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <div class="form-group">
            <small class="text-danger" v-show="errorData" v-html="errorData"></small>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="text">Please contact your doctor for your results!</p>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {DatePicker} from 'element-ui'
  import axios from 'axios'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import Cleave from 'cleave.js'
  require('cleave.js/dist/addons/cleave-phone.us')
//  PATIENT NAME
//  PATIENT ADDRESS
//  PATIENT SEX
//  PATIENT DOB
//  PATIENT CODE
//  PATIENT EMAIL ADDRESS
//  PATIENT INSURANCE DETAILS
  export default {
    components: {
      [DatePicker.name]: DatePicker
    },
    mixins: [FormatterUtils, ValidationUtils],
    data () {
      return {
        errorData: '',
        errorDate: '',
        translatedFields: '',
        model: {
          firstName: '',
          lastName: '',
          dob: '',
          dob_pretty: '',
          code: this.$route.query.confirmation_number
        },
        fields_en: {
          please_tell_us_about_yourself: 'Please tell us about yourself',
          first_name: 'First Name',
          last_name: 'Last Name',
          date_of_birth: 'Date Of Birth',
          confirmation_number: 'Confirmation Number'
        },
        modelValidations: {
          firstName: {
            min: 2,
            required: true
          },
          lastName: {
            min: 2,
            required: true
          },
//          dob: {
//            required: true
//            date_format: 'yyyy-MM-dd'
//            regex: '^(0[1-9]|1[012])[-/.](0[1-9]|[12][0-9]|3[01])[-/.](19|20)\\d\\d$'
//          },
          code: {
            required: true
          },
          siteCode: {
            required: true
          }
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        return new Promise((resolve, reject) => {
          this.model['send_method_email'] = process.env.SECURITY_CODE_BY_EMAIL
          this.model['send_method_text'] = process.env.SECURITY_CODE_BY_TEXT
          this.model['site_code'] = this.$store.state.results.site.site_code
          axios.post(process.env.SERVER_URI + '/check_user_data', this.model)
          .then(async (response) => {
            if (response.data === false) {
              this.errorData = 'Invalid Data!'
              reject(new Error('Invalid Data!'))
            } else {
              this.errorData = ''
              this.$store.state.results.user = response.data
            }
            resolve(true)
          }).catch(() => {
            this.errorData = 'Invalid Data or server issues!'
            reject(new Error('Invalid Data or server issues!'))
          })
        })
      },
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      }
    },
    computed: {
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      },
      ...mapFields(['firstName', 'lastName', 'dob', 'code', 'siteCode'])
    },
    watch: {
      language () {
        this.checkLanguage()
      },
      'model.dob_pretty': {
        handler: function (dobValue) {
          let dateCleave = new Cleave('.date-cleave-format', {
            date: true,
            delimiter: '/',
            datePattern: ['m', 'd', 'Y']
          })
          this.model.dob_pretty = dateCleave.getFormattedValue()
          if (dobValue.length === 10) {
            let dateParts = dobValue.split('/')
            this.model.dob = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
          }
        },
        deep: true
      }
    }
  }
</script>
<style scoped>

>>> .el-select--large{
      width: 100%;
    }

  .required:after {
    content:" *";
    color: red;
  }

  h5{
    margin-bottom: 25px;
  }

  .text{
    text-align: center;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Results/Wizard/Data.vue